import formatPercent from './formatPercent';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { useDeleteWithholding_docMutation } from '../withholding_docsApiSlice';

function formatDate(value) {
  if (!value) return '—';
  try {
    return format(new Date(value), 'yyyy-MM-dd');
  } catch {
    return '—';
  }
}

function formatCurrency(value) {
  return `Rp ${Number(value || 0).toLocaleString('id-ID')}`;
}

function StatusBadge({ status }) {
  if (status === 'NORMAL') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
        NORMAL
      </span>
    );
  }

  if (status === 'PEMBETULAN') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-200">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500"></span>
        PEMBETULAN
      </span>
    );
  }

  if (status === 'DIBATALKAN') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
        <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span>
        DIBATALKAN
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-200">
      {status || 'UNKNOWN'}
    </span>
  );
}

export default function Withholding_docRow({ withholding_doc, index }) {
  const [deleteWithholding_doc, { isLoading }] =
    useDeleteWithholding_docMutation();

  const handleDelete = async () => {
    const ok = window.confirm(
      `Delete withholding doc "${withholding_doc.doc_number || withholding_doc.withholding_doc_id}"?`
    );

    if (!ok) return;

    try {
      await deleteWithholding_doc({ id: withholding_doc.id }).unwrap();
    } catch (err) {
      console.error('Delete error:', err);
      alert(err?.data?.message || 'Failed to delete withholding doc');
    }
  };

  return (
    <tr className="hover:bg-gray-50/40">
      <td className='px-6 py-3 text-sm font-medium text-gray-900'>
        {index + 1}
      </td>
      <td className="px-6 py-3 text-sm font-medium text-gray-900">
        {withholding_doc.withholding_doc_id || '—'}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        <div className="font-medium text-gray-800">
          {withholding_doc.doc_number || '—'}
        </div>
        <div className="text-xs text-gray-500">
          {formatDate(withholding_doc.doc_date)}
        </div>
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {withholding_doc.payer_name || '—'}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {withholding_doc.payer_npwp || '—'}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {withholding_doc.sifat_pemotongan || '—'}
      </td>

      <td className="px-6 py-3">
        <StatusBadge status={withholding_doc.status_bukti_pemotongan} />
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {formatCurrency(withholding_doc.gross_income)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {formatCurrency(withholding_doc.gross_deduction_amount)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
        {formatPercent(withholding_doc.dpp_percent)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {formatCurrency(withholding_doc.net_income)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600 whitespace-nowrap">
        {formatPercent(withholding_doc.tax_rate_percent)}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {formatCurrency(withholding_doc.tax_withheld)}
      </td>


      <td className="px-6 py-3 text-sm text-gray-600">
        {(withholding_doc.tax_year || '—')}
      </td>

      <td className="px-6 py-3 text-sm text-gray-600">
        {(withholding_doc.tax_month || '—')}
      </td>

      <td className="px-6 py-3 text-right">
        <div className="inline-flex gap-2">
          <Link
            to={`/dash/withholding_docs/${withholding_doc.id}`}
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          >
            Edit
          </Link>

          <button
            onClick={handleDelete}
            disabled={isLoading}
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-60"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </td>
    </tr>
  );
}